import { render, staticRenderFns } from "./FeedbackRMA.vue?vue&type=template&id=293f156c&"
import script from "./FeedbackRMA.vue?vue&type=script&lang=js&"
export * from "./FeedbackRMA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports